'use client';

import type { FC } from 'react';
import { BonusSection } from '@/components/hub/BonusSection';
import { EsportsSection } from '@/components/hub/EsportsSection';
import { ExpertReviewSection } from '@/components/hub/ExpertReviewSection';
import { FeaturesSection } from '@/components/hub/FeaturesSection';
import { OverviewSection } from '@/components/hub/OverviewSection';
import { PaymentsSection } from '@/components/hub/PaymentsSection';
import type { Bookmaker } from '@/types/bookmaker';

type MainContentProps = {
  data: Bookmaker;
};

export const MainContent: FC<MainContentProps> = ({ data }) => {
  const {
    BaseReviewTitle,
    BaseReviewText,
    BaseReviewPros,
    BaseReviewCons,
    BonusOfferTitle,
    BonusOfferText,
    BonusOfferPros,
    BonusOfferCons,
    BonusOfferValue,
    BonusOfferValueDescription,
    Code,
    BookmakerFeaturesTitle,
    BookmakerFeaturesText,
    BookmakerFeaturesPros,
    BookmakerFeaturesCons,
    BookmakerFeaturesImages,
    EsportsBettingFeaturesTitle,
    EsportsBettingFeaturesText,
    EsportsBettingFeaturesImages,
    AvailableGamesImages,
    PaymentsAndWithdrawalsTitle,
    PaymentsAndWithdrawlsText,
    PaymentsAndWithdrawlsImages,
    PaymentOptions,
    FeaturedPaymentsImages,
    ExpertReviewText,
    Percentage,
  } = data.attributes;

  return (
    <div className="flex flex-col gap-5" id="review">
      <OverviewSection
        cons={BaseReviewCons}
        pros={BaseReviewPros}
        text={BaseReviewText}
        title={BaseReviewTitle}
      />
      <BonusSection
        code={Code}
        cons={BonusOfferCons}
        pros={BonusOfferPros}
        text={BonusOfferText}
        title={BonusOfferTitle}
        value={BonusOfferValue}
        valueDescription={BonusOfferValueDescription}
      />
      <FeaturesSection
        cons={BookmakerFeaturesCons}
        images={BookmakerFeaturesImages}
        pros={BookmakerFeaturesPros}
        text={BookmakerFeaturesText}
        title={BookmakerFeaturesTitle}
      />
      <EsportsSection
        availableGames={AvailableGamesImages}
        images={EsportsBettingFeaturesImages}
        text={EsportsBettingFeaturesText}
        title={EsportsBettingFeaturesTitle}
      />
      <PaymentsSection
        featuredPayments={FeaturedPaymentsImages}
        images={PaymentsAndWithdrawlsImages}
        paymentOptions={PaymentOptions}
        text={PaymentsAndWithdrawlsText}
        title={PaymentsAndWithdrawalsTitle}
      />
      <ExpertReviewSection percentage={Percentage} text={ExpertReviewText} />
    </div>
  );
};
